var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.558 497.323c19.668 174.32 166.631 310.73 347.232 317.419 1.060 0.169 2.147 0.257 3.254 0.257h21.178c200.617 0 363.378-160.011 363.378-357.592 0-197.56-162.765-357.567-363.378-357.567h-61.881c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48c7.541 0 28.167 0 61.881 0 178.147 0 322.418 141.826 322.418 316.607 0 174.802-144.268 316.632-322.418 316.632h-10.524c-168.259 0-306.294-126.518-321.103-287.84l67.342 51.138c11.138 8.458 27.023 6.285 35.481-4.853s6.285-27.023-4.853-35.481l-107.546-81.667c-11.138-8.458-27.023-6.285-35.481 4.853l-81.667 107.546c-8.458 11.138-6.285 27.023 4.853 35.481s27.023 6.285 35.481-4.853l46.352-61.040zM595.241 468.48l81.685-80.522c12.083-11.911 12.222-31.361 0.311-43.444s-31.361-12.222-43.444-0.311l-82.313 81.141-79.355-78.225c-12.083-11.911-31.533-11.771-43.444 0.311s-11.771 31.533 0.311 43.444l78.728 77.607-78.728 77.607c-12.083 11.911-12.222 31.361-0.311 43.444s31.361 12.222 43.444 0.311l79.355-78.225 82.313 81.141c12.083 11.911 31.533 11.771 43.444-0.311s11.771-31.533-0.311-43.444l-81.685-80.522z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.bad0ebfde8a082bc5d4c02d571f3c91f.svg";
export { ForwardRef as ReactComponent };